<template>
	<div>
		<v-container>
			<v-row>
				<v-col cols="12">
					<v-breadcrumbs :items="breadcrumbs">
						<template #divider>
							<v-icon>mdi-chevron-left</v-icon>
						</template>
					</v-breadcrumbs>
				</v-col>
			</v-row>

			<v-expansion-panels class="pt-2 pb-5">
				<v-expansion-panel>
					<v-expansion-panel-header disable-icon-rotate>
						<template #default="{ open }">
							<v-row no-gutters class="text-center">
								<v-col cols="12" class="text--secondary">
									<v-fade-transition leave-absolute>
										<span v-if="open" key="0">
											التصفية
											<v-icon color="primary" left>mdi-filter</v-icon>
										</span>
										<span v-else key="1">
											التصفية
											<v-icon color="primary" left>mdi-filter</v-icon>
										</span>
									</v-fade-transition>
								</v-col>
							</v-row>
						</template>
						<template #actions>
							<v-icon color="primary"></v-icon>
						</template>
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<v-row justify="center" dense>
							<v-col cols="12" md="4">
								<v-select
									v-model="filters.itemsPerPage"
									hide-details
									outlined
									label="عدد السجلات في الصفحة"
									:items="itemsPerPage"
								></v-select>
							</v-col>
							<v-col cols="12" class="text-center">
								<v-btn color="success" @click="applyFilter">تصفية</v-btn>
							</v-col>
						</v-row>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>

			<v-data-table
				id="table"
				class="elevation-1"
				:headers="headers"
				:items="records"
				hide-default-footer
				:loading="loading"
				:items-per-page="-1"
				dense
			>
				<template #top>
					<v-toolbar flat>
						<v-toolbar-title class="px-4">سجل العمليات</v-toolbar-title>
						<v-divider insert vertical></v-divider>
						<v-spacer></v-spacer>
						<v-btn color="warning" class="white--text mx-1" :disabled="!privs.clear" @click=";">
							Clear
							<v-icon right>mdi-notification-clear-all</v-icon>
						</v-btn>
						<v-btn color="green" class="white--text mx-1" :disabled="!privs.backup" @click="exportToExcel">
							تصدير الجدول كملف اكسل
							<v-icon right>mdi-microsoft-excel</v-icon>
						</v-btn>
					</v-toolbar>
				</template>

				<template #[`item.oldData`]="{ item }">
					<json-view :data="item.oldData" :max-depth="3" dir="ltr" root-key></json-view>
				</template>

				<template #[`item.newData`]="{ item }">
					<json-view :data="item.newData" :max-depth="3" dir="ltr" root-key></json-view>
				</template>
			</v-data-table>

			<v-pagination v-model="page" :length="pageCount" class="pt-3"></v-pagination>
		</v-container>
	</div>
</template>

<script>
import client from "@/client";
import { JSONView } from "vue-json-component";

export default {
	components: { "json-view": JSONView },
	mixins: [require("@/mixins/router-mixin").default],
	data() {
		return {
			privs: {},
			breadcrumbs: [
				{
					text: "لوحة التحكم",
					disabled: false,
					to: { name: "dashboard-home" }
				},
				{ text: "سجل المنصة", disabled: true }
			],
			headers: [
				{
					text: "رقم السجل",
					value: "id"
				},
				{
					text: "اسم الجدول",
					value: "tableName"
				},
				{
					text: "رقم المعرف",
					value: "recordID"
				},
				{
					text: "نوع العملية",
					value: "actionType"
				},
				{
					text: "من قام بالعملية",
					value: "userID"
				},
				{
					text: "تاريخ الانشاء",
					value: "created_at"
				},
				{
					text: "تاريخ التحديث",
					value: "updated_at"
				},
				{
					text: "البيانات القديمة",
					value: "oldData"
				},
				{
					text: "البيانات الجديدة",
					value: "newData"
				}
			],
			records: [],
			pageCount: 1,
			page: 1,
			filters: {
				stateID: null,
				writerID: null,
				publisherID: null,
				userGroupID: null,
				startDate: null,
				endDate: null,
				itemsPerPage: null
			},
			states: [
				{ text: "غير مكتملة", value: "notCompleted" },
				{ text: "مسودة", value: "draft" },
				{ text: "محفوظة", value: "submited" },
				{ text: "منشورة", value: "published" }
			],
			loading: true,
			actionLoading: false,
			users: [],
			groups: [],
			storedFilters: {},
			itemsPerPage: [10, 50, 100, 500, 1000, 99999999]
		};
	},
	watch: {
		page(newVal) {
			this.loading = true;
			this.getRecords(newVal);
		}
	},
	mounted() {
		this.getPrivileges();
		this.getRecords(1);
		// this.getUsers();
		// this.getUserGroups();
	},
	methods: {
		getPrivileges() {
			client
				.get("/api/privilege/logIcons")
				.then(response => {
					console.log(response);
					this.privs = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
		refresh() {
			this.actionLoading = false;
			this.loading = true;
			this.records = [];
			this.getRecords(this.page);
		},
		getRecords(page) {
			client
				.post("/api/system/log?page=" + page, this.storedFilters)
				.then(response => {
					this.pageCount = response.data.data.last_page;
					this.records = Object.values(response.data.data.data).map(
						record => {
							if (record.newData) {
								record.newData = JSON.parse(record.newData);
							}
							if (record.oldData) {
								record.oldData = JSON.parse(record.oldData);
							}
							return record;
						}
					);
					this.loading = false;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		applyFilter() {
			this.storedFilters = { ...this.filters };
			this.records = [];
			this.loading = true;
			this.getRecords(1);
		},
		exportToExcel() {
			var downloadurl;
			var dataFileType = "application/vnd.ms-excel";
			var tableSelect = document.getElementById("table");
			var tableHTMLData = tableSelect.outerHTML.replace(/ /g, "%20");
			const filename =
				"Ertiqa log " +
				new Date().toISOString().substring(0, 10) +
				".xls";
			downloadurl = document.createElement("a");
			document.body.appendChild(downloadurl);
			if (navigator.msSaveOrOpenBlob) {
				var blob = new Blob(["\ufeff", tableHTMLData], {
					type: dataFileType
				});
				navigator.msSaveOrOpenBlob(blob, filename);
			} else {
				downloadurl.href =
					"data:" + dataFileType + ", " + tableHTMLData;
				downloadurl.download = filename;
				downloadurl.click();
			}
		}
	}
};
</script>